import { render, staticRenderFns } from "./CommentProcView.vue?vue&type=template&id=1107cd9a&scoped=true&"
import script from "./CommentProcView.vue?vue&type=script&lang=js&"
export * from "./CommentProcView.vue?vue&type=script&lang=js&"
import style0 from "./CommentProcView.vue?vue&type=style&index=0&id=1107cd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107cd9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
